import { Uuid } from "@/domains/global/identifiers";

export enum TransformPhase {
  Idle = "idle",
  Uploading = "uploading",
  Transcribing = "transcribing",
  Processing = "processing",
}

export enum TransformMode {
  StandardFlow = "standard_flow",
  TranscriptionFromSourceRequired = "transcription_from_source_required",
}

export type AudioRecordingTransformingState = {
  isTransforming: boolean;
  errorMessage: string | null;
  apiCallCompletedAt: number | null;
  /** Current phase during transformation for UI display */
  phase: TransformPhase;
  mode: TransformMode;
};

export interface AudioRecordingTransformProgressTracker {
  setTransformState({
    audioRecordingId,
    state,
  }: {
    audioRecordingId: Uuid;
    state: AudioRecordingTransformingState;
  }): void;
  clearTransformState({ audioRecordingId }: { audioRecordingId: Uuid }): void;
  getTransformState({
    audioRecordingId,
  }: {
    audioRecordingId: Uuid;
  }): AudioRecordingTransformingState;
}

export type TransformCompletionResult = { success: true } | { success: false; error: string };

export interface IAudioTransformingStore extends AudioRecordingTransformProgressTracker {
  enqueue({ audioRecordingId }: { audioRecordingId: Uuid }): Promise<void>;
  waitForTransformComplete({
    audioRecordingId,
  }: {
    audioRecordingId: Uuid;
  }): Promise<TransformCompletionResult>;
  resetState(): void;
}
